import { render, staticRenderFns } from "./OffersListDetailsFiltersPNTs.vue?vue&type=template&id=7535d97a"
import script from "./OffersListDetailsFiltersPNTs.vue?vue&type=script&lang=js"
export * from "./OffersListDetailsFiltersPNTs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports